import type { SourceCell } from "./types";

export function cellToString(cell: SourceCell | undefined): string {
  if (cell == null) return "";
  if (cell instanceof Date) return cell.toISOString().slice(0, 10);
  return String(cell);
}
